module.exports = __webpack_public_path__ + "img/floor2_9.a3cce103.jpg";